<template>
  <div class="properties">
        <ul>
          <li v-for="property in adminProperties" :key="property.id" v-on:click="setProperty(property)">
            <div class="property-wrapper">
              <img :src="property.logo" :alt="property.name" />
              <div class="text" v-if="!isDash">
                <span class="select">Select</span>
              </div>
              <div class="switch" v-if="isDash">
                <span>Switch</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'PropertyList',
  props: ["isDash"],
  data: function () {
    return {
    };
  },
  computed: {
    adminProperties() {
      let adminProperties = [];
      this.properties.forEach((property) => {
          console.log({thisProp:this.property, listProp:property});
        if ((!this.isDash && property.account == 'admin') || (this.isDash && this.property.id !== property.id)) {
          adminProperties.push(property);
        }
      });
      return adminProperties;
    },
    ...mapState('session', ['properties', 'property', 'prevPath']),
  },
  watch: {
    property: {
      immediate: false,
      handler(newVal) {
        if (newVal !== null) {
          this.$router.push(this.getRedirectPath()).catch(()=>{this.$router.go()}); //todo: fix to use state switch
          this.$store.dispatch('session/setPrevPath', '');
        }
      }
    },
  },
  methods: {
    setProperty: function(property) {
      if (this.property && property.id == this.property.id) {
        this.$router.push(this.getRedirectPath());
      }
      else {
        this.$store.dispatch('session/setProperty', { property: property });
      }
    },
    getRedirectPath: function() {
      return this.prevPath || '/dashboard';
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/_variables";

div.properties {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap!important;
  .property-wrapper {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap!important;
    margin: 0 0 0 50px;
    justify-content: space-between;
    .switch{
        font-family: HelveticaNeue;
        font-size: 12px;
        color: #FF5A5F;
        letter-spacing: 0;
        text-align: right;
        text-align: center;
        margin-left: 15px;
      }
      >img {
      max-width: 100px;
      height: auto;
    }
  }
}

ul {
  list-style: none;
  width: 100%;
  box-shadow: 0 10px 30px 0 rgba(0,0,0,0.07);
  border-radius: 4px;
  padding: 0;
  margin: 0;
  &:first-child li {
    border-bottom: 1px solid #ecececa2;
  }

  li {
    width: 100%;
    display: inline-flex;
    justify-content: flex-start;
    align-items: center;
    padding: 26px 15px;
    background-color: white;
    cursor: pointer;
    transition: background-color 250ms;

    &:hover {
      background-color: #f7f7f7;
    }

    div.text {
      display: flex;
      justify-content: flex-end;
      margin-right: 50px;
      span {
        padding: 11px 49px;
        display: block;
        background: #FF5A5F;
        font-family: HelveticaNeue;
        font-size: 16px;
        color: #FFFFFF;
        letter-spacing: 0;
        text-align: center;
        &:hover {
          cursor: pointer;
          background: #e24f54;
        }
      }
    }

    span.name {
      font-size: 1rem;
    }

    span.account {
      font-size: 0.75rem;
      color: #999;
      text-transform: capitalize;
    }
  }
}
</style>
